module.exports = __webpack_public_path__ + "static/media/view-icon~bnQfWdEi.4221c12d.svg";